import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOut } from 'components/sharpr/util/spliceOut';
import _ from 'lodash';

let announcements;

export function AnnouncementResolves(resolves) {
	resolves.__checkForAnnouncements = ApiResourcify.endpoint('/announcements', {
		withResponse: resp => (announcements = resp.data || []),
		cacheFor: 4 * 60 * 60 * 1000, // 4 hours
	});
}

/**
 * Intercept ui-router controller activation and block if user has no permission
 * @param {Object} $rootScope  The angular rootScope, where the ui-router broadcasts its $stateChangeStart event
 * @param {Object} notifications  The ng-notifications-bar service used to alert user that access is denied
 */
export function checkForAnnouncements($rootScope, Announcement) {
	'ngInject';
	// check to see if we need to popup any announcements for this route
	$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
		Announcement.popupIfNeeded(toState.url);
	});
}

export class AnnouncementService {
	constructor(Api, $rootScope, $compile) {
		'ngInject';
		this.Api = Api;
		this.$rootScope = $rootScope;
		this.$compile = $compile;
	}

	getNextAnnouncement(routeUrl) {
		const idx = _.findIndex(announcements, { route_url: routeUrl });
		if (idx > -1) {
			const next = announcements[idx];
			announcements.splice(idx, 1);
			return next;
		} else {
			return null;
		}
	}

	popupIfNeeded(routeUrl) {
		const record = this.getNextAnnouncement(routeUrl);
		if (!record) {
			return;
		}
		const $scope = this.$rootScope.$new();
		$scope.record = record;
		this.closeAnnouncement = () => {
			element.remove();
			$scope.$destroy();
			this.closeAnnouncement = null;
		};
		let element = angular.element(`
			<sh-announcement record="record"></sh-announcement>
		`);
		element = this.$compile(element)($scope);
		angular.element(document.body).append(element);
	}

	closePopup() {
		if (this.closeAnnouncement) {
			this.closeAnnouncement();
		}
	}

	markAsSeen(record) {
		this.Api.post(`/announcements/${record.id}/seen`);
	}
}
